import React from "react";

export function Logo({ size = 36, withText = true, light = false }) {
  const textColor = light ? "text-white" : "text-[#0B192C]";
  return (
    <div className="flex items-center gap-2.5" data-testid="brand-logo">
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="Vishwakarma Nexus logo"
      >
        <rect width="48" height="48" rx="12" fill="#2563EB" />
        <path
          d="M12 13 L24 35 L36 13"
          stroke="#D4AF37"
          strokeWidth="3.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <circle cx="24" cy="13" r="2.6" fill="#D4AF37" />
        <circle cx="12" cy="13" r="2.2" fill="#D4AF37" opacity="0.7" />
        <circle cx="36" cy="13" r="2.2" fill="#D4AF37" opacity="0.7" />
      </svg>
      {withText && (
        <div className="leading-none">
          <div className={`font-head font-extrabold tracking-tight text-[15px] sm:text-base ${textColor}`}>
            VISHWAKARMA
          </div>
          <div className="font-head font-semibold tracking-[0.3em] text-[9px] sm:text-[10px] text-[#B8860B]">
            NEXUS
          </div>
        </div>
      )}
    </div>
  );
}

export default Logo;
